<script setup lang="ts">
import { computed } from 'vue';
import DataTable from 'primevue/datatable';
import ToggleSwitch from 'primevue/toggleswitch';
import TableColumn from 'primevue/column';

interface Props {
  configurationRoleManagement: any;
  roleUpdateEdit: boolean;
  typeRoleHeader: string;
}
const props = defineProps<Props>();

const emits = defineEmits<{ 'update:configurationRoleManagement': [value: any] }>();

const configuration_role_management = computed({
  get() {
    return props.configurationRoleManagement;
  },
  set(value) {
    emits('update:configurationRoleManagement', value);
  }
});
</script>
<template>
  <div>
    <DataTable :value="configuration_role_management" showGridlines :rows="170" dataKey="id" filterDisplay="menu">
      <TableColumn field="rowname" :header="typeRoleHeader" class="w-4rem min-w-20rem" frozen>
        <template #body="{ data }">
          <span v-tooltip="data.code">
            {{ $t(`permisson.${data.rowname}`) }}
          </span>
        </template>
      </TableColumn>
      <TableColumn field="admin" :header="$t('role.admin')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!roleUpdateEdit" v-model="data.admin" />
        </template>
      </TableColumn>
      <TableColumn field="co" :header="$t('role.groups_coordinator')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!roleUpdateEdit" v-model="data.co" />
        </template>
      </TableColumn>
      <TableColumn field="rm" :header="$t('role.revenua_management')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!roleUpdateEdit" v-model="data.rm" />
        </template>
      </TableColumn>
      <TableColumn field="gc" :header="$t('role.groups_commercial')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!roleUpdateEdit" v-model="data.gc" />
        </template>
      </TableColumn>
      <TableColumn field="ao" :header="$t('role.group_air')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!roleUpdateEdit" v-model="data.ao" />
        </template>
      </TableColumn>
      <TableColumn field="cr" :header="$t('role.group_cruise')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!roleUpdateEdit" v-model="data.cr" />
        </template>
      </TableColumn>
      <TableColumn field="in" :header="$t('role.group_incentives')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!roleUpdateEdit" v-model="data.in" />
        </template>
      </TableColumn>
      <TableColumn field="su" :header="$t('role.supervisor')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!roleUpdateEdit" v-model="data.su" />
        </template>
      </TableColumn>
      <TableColumn field="asm" :header="$t('role.sales_team')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!roleUpdateEdit" v-model="data.asm" />
        </template>
      </TableColumn>
      <TableColumn field="tagent" :header="$t('role.travel_agent')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!roleUpdateEdit" v-model="data.tagent" />
        </template>
      </TableColumn>
      <TableColumn field="marketing" :header="$t('role.marketing_management')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!roleUpdateEdit" v-model="data.marketing" />
        </template>
      </TableColumn>
      <TableColumn field="accounting" :header="$t('role.accounting')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!roleUpdateEdit" v-model="data.accounting" />
        </template>
      </TableColumn>
      <TableColumn field="support" :header="$t('role.it_support')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!roleUpdateEdit" v-model="data.support" />
        </template>
      </TableColumn>
    </DataTable>
  </div>
</template>
